import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言文件
import en from './translations/en';
import de from './translations/de';
import es from './translations/es';
import it from './translations/it';
import zh from './translations/zh';
import pl from './translations/pl';
import fr from './translations/fr';

// 初始化i18n
i18n
  .use(LanguageDetector)  // 使用浏览器语言检测器
  .use(initReactI18next)  // 将i18n实例传递给react-i18next
  .init({
    resources: {
      en,
      de,
      es,
      it,
      zh,
      pl,
      fr
    },
    fallbackLng: 'en',  // 默认语言
    debug: process.env.NODE_ENV === 'development',  // 开发环境下启用调试模式
    interpolation: {
      escapeValue: false,  // React 已经转义所有内容
    },
    detection: {
      order: ['localStorage', 'navigator'],  // 首先检查本地存储，然后是浏览器设置
      lookupLocalStorage: 'i18nextLng',  // 本地存储中存储语言选择的键名
      caches: ['localStorage']  // 将语言选择保存在本地存储中
    }
  });

export default i18n;